import { render, staticRenderFns } from "./TicketDetailsUser.vue?vue&type=template&id=285af654&scoped=true&"
import script from "./TicketDetailsUser.vue?vue&type=script&lang=js&"
export * from "./TicketDetailsUser.vue?vue&type=script&lang=js&"
import style0 from "./TicketDetailsUser.vue?vue&type=style&index=0&id=285af654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285af654",
  null
  
)

export default component.exports